export class Features {
    public id: number;
    public name: string;
    public fullName: string;
    public description: string;
    public assemblyQualifiedName: string;
    public className: string; 
}
